import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: ReactNode;
  action?: ReactNode;
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="text-center py-20 px-6">
      <div className="mx-auto w-14 h-14 rounded-full bg-warmgrey/60 flex items-center justify-center text-2xl text-secondary mb-5">
        {icon ?? '∅'}
      </div>
      <h2 className="text-xl font-bold text-primary mb-2 normal-case tracking-normal">{title}</h2>
      {description && (
        <p className="text-sm text-secondary max-w-md mx-auto mb-5 leading-relaxed">
          {description}
        </p>
      )}
      {action && <div className="flex justify-center gap-2 flex-wrap">{action}</div>}
    </div>
  );
}
